import { render, staticRenderFns } from "./ProviderCNAAdd.vue?vue&type=template&id=2c3a8a96&scoped=true"
import script from "./ProviderCNAAdd.vue?vue&type=script&lang=js"
export * from "./ProviderCNAAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a8a96",
  null
  
)

export default component.exports